/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerdetails1Inputs */

const en_organizerdetails1 = /** @type {(inputs: Organizerdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const de_organizerdetails1 = /** @type {(inputs: Organizerdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angaben`)
};

/**
* | output |
* | --- |
* | "Details" |
*
* @param {Organizerdetails1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerdetails1 = /** @type {((inputs?: Organizerdetails1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerdetails1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerdetails1(inputs)
	return de_organizerdetails1(inputs)
});
export { organizerdetails1 as "organizerDetails" }